import React from "react"
import Navbar1 from "../Components/Header";
import Footer1 from "../Components/Footer1";
import Loader from "../Components/Loader";
import "../CSS/ServicePage.css";

export const ServicePage = () => {
    return (
        <>
        <Loader/>
        <div className="Servicepage">
        <Navbar1/>
        <div className="container">
        <div id="webcrumbs2">
            <div className="w-full max-w-[1280px] bg-gradient-to-br font-sans mx-auto">
                <header className="py-12 md:py-20 px-6 md:px-10 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-blue-500 opacity-5 transform -skew-y-6"></div>
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-slate-800 relative z-10">
                        AI Development Services
                    </h1>
                    <p className="text-lg md:text-xl max-w-3xl mx-auto relative z-10">
                        Transforming businesses with cutting-edge artificial intelligence solutions
                    </p>
                    <div className="flex flex-col md:flex-row justify-center mt-8 md:mt-10 space-y-4 md:space-y-0">
                        <button className="bg-blue-600 text-white px-6 md:px-8 py-3 rounded-lg md:mr-4 font-medium transition-all duration-300 hover:bg-blue-700 hover:shadow-lg transform hover:-translate-y-1">
                            Get Started
                        </button>
                        <button className="bg-white text-blue-600 px-6 md:px-8 py-3 rounded-lg font-medium border-2 border-blue-600 transition-all duration-300 hover:bg-blue-50 hover:shadow-md transform hover:-translate-y-1">
                            Learn More
                        </button>
                    </div>
                    {/* Next: "Add an animated scroll indicator arrow" */}
                </header>

                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16 text-slate-800">
                        Why Choose Our AI Development
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-blue-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-blue-600 text-2xl md:text-3xl">
                                    smart_toy
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Expertise & Innovation
                            </h3>
                            <p className="text-gray-600">
                                Our team of AI specialists brings decades of combined experience in developing
                                cutting-edge solutions that drive real business outcomes.
                            </p>
                        </div>

                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-indigo-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-indigo-600 text-2xl md:text-3xl">
                                    trending_up
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Scalable Solutions
                            </h3>
                            <p className="text-gray-600">
                                We design AI systems that grow with your business, ensuring long-term value and
                                adaptability to changing market conditions.
                            </p>
                        </div>

                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-cyan-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-cyan-600 text-2xl md:text-3xl">
                                    security
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Ethical AI Practices
                            </h3>
                            <p className="text-gray-600">
                                We prioritize responsible AI development with transparent algorithms and bias-free
                                models that respect privacy and security.
                            </p>
                        </div>
                    </div>
                    {/* Next: "Add a 'View all features' button" */}
                </section>

                <section className="py-12 md:py-16 px-6 md:px-10 bg-gradient-to-r from-slate-800 to-blue-900 text-white">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16">How AI Adds Value</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-blue-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-blue-400 p-6 md:p-8 rounded-lg bg-blue-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-blue-300">
                                        insights
                                    </span>
                                    Data-Driven Decision Making
                                </h3>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Transform raw data into actionable business intelligence</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Reduce decision-making time by up to 70%</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Identify patterns and trends human analysis might miss</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-indigo-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-indigo-400 p-6 md:p-8 rounded-lg bg-indigo-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-indigo-300">
                                        auto_awesome
                                    </span>
                                    Automation & Efficiency
                                </h3>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Automate repetitive tasks and workflows</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Reduce operational costs by up to 40%</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Free up human resources for creative and strategic work</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-cyan-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-cyan-400 p-6 md:p-8 rounded-lg bg-cyan-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-cyan-300">
                                        person_search
                                    </span>
                                    Personalized Customer Experience
                                </h3>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Deliver customized interactions at scale</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Increase customer satisfaction by up to 35%</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Build deeper customer relationships through intelligent engagement</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-purple-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-purple-400 p-6 md:p-8 rounded-lg bg-purple-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-purple-300">
                                        trending_up
                                    </span>
                                    Predictive Analytics
                                </h3>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Forecast market trends and customer behavior</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Reduce inventory costs by up to 30%</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Mitigate risks through early issue identification</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Next: "Add a case study section with real-world examples" */}
                </section>

                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16 text-slate-800">
                        AI Development Statistics
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16">
                        <div className="bg-gradient-to-br from-blue-500 to-indigo-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2">87%</h3>
                            <p className="text-blue-100 text-base md:text-lg">
                                of businesses report positive ROI from AI investments within 12 months
                            </p>
                        </div>

                        <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2">3.5x</h3>
                            <p className="text-indigo-100 text-base md:text-lg">
                                increase in productivity when implementing AI-driven workflow systems
                            </p>
                        </div>

                        <div className="bg-gradient-to-br from-cyan-500 to-blue-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2">$15.7T</h3>
                            <p className="text-cyan-100 text-base md:text-lg">
                                potential contribution to the global economy by 2030
                            </p>
                        </div>
                    </div>

                    {/* <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl">
                        <h3 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-slate-800 text-center">
                            AI Adoption by Industry
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                            <div className="space-y-6">
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Healthcare</span>
                                        <span className="font-medium">76%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[76%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Financial Services</span>
                                        <span className="font-medium">82%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[82%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Retail</span>
                                        <span className="font-medium">68%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[68%] transition-all duration-1000"></div>
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Manufacturing</span>
                                        <span className="font-medium">71%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[71%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Transportation</span>
                                        <span className="font-medium">64%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[64%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Energy & Utilities</span>
                                        <span className="font-medium">59%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[59%] transition-all duration-1000"></div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>*/}
                    
                </section>
                <section className="py-12 md:py-16 px-4 md:px-6">
                    <div className="text-center mb-8 md:mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">Technologies We Use</h2>
                        <p className="max-w-2xl mx-auto">
                            Our development stack combines the most powerful and flexible technologies to deliver
                            exceptional solutions.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8">
                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-blue-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands fa-react text-5xl text-blue-500"></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">React</h3>
                            <p className="text-gray-600 text-sm text-center">
                                Frontend library for building user interfaces
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-green-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands fa-node-js text-5xl text-green-600"></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Node.js</h3>
                            <p className="text-gray-600 text-sm text-center">
                                Server-side JavaScript runtime environment
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-green-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <svg className="w-12 h-12" viewBox="0 0 32 32" fill="none">
                                    <path
                                        d="M15.9.087l.854 1.604c.192.296.4.558.645.802.715.715 1.394 1.464 2.004 2.266 1.447 1.9 2.423 4.01 3.12 6.292.418 1.394.645 2.824.662 4.27.07 4.323-1.412 8.035-4.4 11.12-.488.488-1.01.94-1.57 1.342-.296 0-.436-.227-.558-.436-.227-.383-.366-.802-.436-1.222-.105-.614-.105-1.227-.105-1.84v-.305c-.105.01-.227-.105-.227-.197-.105-.21-.21-.436-.296-.645-.21-.524-.797-.873-1.342-.767-.488.105-.884.505-.884 1.01v.105c-.314.994-.645 1.976-.973 2.96-.14.436-.436.61-.858.61-.42 0-.73-.227-.806-.645-.192-.872-.27-1.734-.453-2.597-.183-.872-.627-1.693-1.287-2.337-.767-.767-1.538-1.464-2.423-2.023-.094-.105-.192-.227-.296-.323-.017-.052-.04-.1-.07-.149L.254 23.172l4.287-2.038c.365-.183.635-.557.635-.975 0-.423-.27-.79-.635-.976l-4.287-2.026 7.79-13.517s.096.017.105.175c.096.923.157 1.828.4 2.738.165.548.358 1.08.575 1.6.323.766.732 1.495 1.18 2.197.58.94 1.278 1.81 2.08 2.6 1.393 1.436 2.886 2.744 4.394 4.058.262.21.558.36.875.36.318 0 .61-.14.853-.36.314-.227.61-.488.886-.766.192-.21.453-.313.732-.313.27 0 .522.105.732.313.42.409.314 1.074-.21 1.39-1.064.664-1.972 1.498-2.675 2.496-.122.17-.244.348-.33.54v.017c-.052.122-.087.244-.096.375-.017.174 0 .366.052.54.174.557.418 1.08.732 1.583.49.766 1.064 1.466 1.55 2.215.142.244.262.505.366.775.175.558.175 1.147.105 1.734-.07.558-.2 1.1-.453 1.584-.105.244-.288.47-.488.662-.244.21-.54.296-.858.296-1.25-.105-2.337-.73-3.382-1.476-1.398-.996-2.735-2.09-3.977-3.27-1.674-1.583-3.254-3.2-4.912-4.747-.21-.21-.488-.21-.7 0-.57.583-1.154 1.156-1.763 1.704-.68.61-1.308 1.29-1.9 2.007-.453.558-.835 1.154-1.113 1.812-.244.558-.384 1.143-.41 1.74 0 .453.105.9.314 1.32.418.83 1.006 1.517 1.62 2.198.45.475.924.93 1.42 1.36l-.013.012 4.55 4.597-2.586 1.9c-.226.21-.436.418-.548.697-.14.314-.105.66.07.96.278.557.766 1.01 1.358 1.204.106 0 .192.106.192.214v2.495s-8.105-5.02-13.285-15.065C.08 16.87-.04 16.362.014 15.832c.07-.558.297-1.08.61-1.518.314-.47.697-.83 1.115-1.126.875-.696 1.743-1.39 2.624-2.09.2-.17.453-.296.696-.296s.497.122.696.296c.78.697 1.516 1.427 2.302 2.09 1.195 1.01 2.42 1.95 3.842 2.586.488.226 1.006.174 1.385-.244.192-.213.297-.493.297-.793 0-.366-.174-.696-.47-.9-.516-.364-1.108-.66-1.673-.935-.153-.07-.297-.174-.47-.226-.245-.063-.508-.063-.764 0-.105-.022-.21-.07-.314-.106-.61-.296-1.204-.662-1.743-1.08-1.042-.823-1.933-1.808-2.624-2.925-.453-.767-.767-1.586-1.115-2.388-.035-.105-.07-.227-.088-.314z"
                                        fill="#10AA50"
                                    />
                                </svg>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">MongoDB</h3>
                            <p className="text-gray-600 text-sm text-center">NoSQL database for modern applications</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-red-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands fa-angular text-5xl text-red-600"></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Angular</h3>
                            <p className="text-gray-600 text-sm text-center">
                                Platform for building mobile & desktop apps
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-blue-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands fa-aws text-5xl text-orange-500"></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">AWS</h3>
                            <p className="text-gray-600 text-sm text-center">
                                Cloud computing services for scalability
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-purple-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M16.633 16.504c.869-.075 1.543-.84 1.499-1.754-.046-.914-.795-1.648-1.708-1.648h-.061c-.943.031-1.678.824-1.648 1.769.03.479.226.869.494 1.153-1.048 2.038-2.621 3.536-5.004 4.795-1.603.838-3.296 1.154-4.944.93-1.378-.195-2.456-.81-3.116-1.798-.988-1.499-1.078-3.116-.255-4.734.6-1.17 1.499-2.023 2.099-2.443-.12-.389-.615-1.499-.93-2.188-.137 0-.27 0-.389.03C1.622 10.963.342 13.347.461 16.082c.075 1.797.899 3.296 2.099 4.253 1.005.782 2.306 1.172 3.775 1.172.93 0 1.873-.137 2.786-.391 5.961-1.217 10.47-6.77 10.904-7.7zm-1.5-2.786c-.442 0-.781-.339-.752-.75 0-.419.34-.749.75-.749.419 0 .749.33.749.749 0 .42-.329.75-.749.75h.002z"
                                        fill="#764ABC"
                                    />
                                    <path
                                        d="M23.685 15.03L20.515 6.5c-.061-.15-.256-.27-.436-.271h-1.14l.06-.226c.165-.602.39-1.088.669-1.544.486-.775.935-1.339.935-1.339s-1.904.307-3.026 2.024a14.922 14.922 0 00-.862 2.044l-.123.352h-.844c-.21 0-.375.12-.464.271l-3.17 8.531c-.015.06-.027.121-.03.18a.74.74 0 00.745.75c.33 0 .599-.211.706-.51l2.85-7.712h.845l-4.076 10.807h1.446l.838-2.027c.21-.586.39-1.141.54-1.665h.122c.12.6.296 1.155.539 1.727l.689 1.965h5.701c.18 0 .375-.12.464-.271l3.17-8.531c.015-.06.027-.121.03-.18a.74.74 0 00-.75-.75.696.696 0 00-.703.51l-2.85 7.72h-.48l.931-2.53c.21-.602.39-1.155.54-1.665h.123c.12.54.3 1.155.539 1.727l.99 2.47h-2.697l-.327-.93a15.76 15.76 0 01-.479-1.485c-.15-.54-.18-1.02-.18-1.02h-.121s-.15.479-.39 1.02a5.57 5.57 0 01-.599 1.425l-.389.99h-2.46l2.85-7.651h.845l-.811 2.16c-.21.586-.39 1.14-.54 1.665h-.121c-.12-.6-.296-1.156-.539-1.727l-.719-2.1h3.33l.718 2.1c.24.571.45 1.127.6 1.727h.121c-.21-.601-.33-1.141-.48-1.665l-.39-2.16h.849z"
                                        fill="#764ABC"
                                    />
                                </svg>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Redux</h3>
                            <p className="text-gray-600 text-sm text-center">
                                State management for JavaScript applications
                            </p>
                        </div>
                    </div>
                </section>


                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10 text-slate-800">
                        Ready to Transform Your Business?
                    </h2>
                    <p className="text-center text-base md:text-lg max-w-3xl mx-auto mb-8 md:mb-10">
                        Let's discuss how our AI development services can address your specific challenges and drive
                        growth.
                    </p>
                    <div className="flex justify-center">
                        <button className="bg-blue-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-medium text-base md:text-lg transition-all duration-300 hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1">
                            Schedule a Consultation
                        </button>
                    </div>
                    {/* Next: "Add a newsletter signup form with email validation" */}
                </section>
            </div>
        </div>
        </div>
        <Footer1/>
        </div>
        </>
    )
}